import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "float-right position-relative" }
const _hoisted_2 = {
  class: "position-absolute text-nowrap",
  style: {
                            top: '-4px',
                            right: 0
                        }
}
const _hoisted_3 = { class: "d-flex mt-3" }
const _hoisted_4 = { class: "flex-fill" }
const _hoisted_5 = {
  key: 0,
  class: "pr-2 pl-4 message-color font-size-small"
}

import {computed, nextTick, onMounted, ref} from "vue";
import createMockMessage from "~/core-ui/vue/chat/createMockMessage";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {__} from "~/ts/library/Translate";
import CoreUiChatHistoryMessage from "~/core-ui/vue/chat/CoreUiChatHistoryMessage.vue";
import {
    MESSAGE_COLOR_COMMENT_OPERATOR_DARK, MESSAGE_COLOR_OPERATOR_COMMENT,
    MESSAGE_COLOR_OPERATOR_DARK
} from "~/operatorApplication/vue/dialogs/dialog/Constants";
import SizeObserverWrapper from "~/core-ui/vue/ui/SizeObserverWrapper.vue";
import CoreUiChatHistoryMessageButton from "~/core-ui/vue/chat/CoreUiChatHistoryMessageButton.vue";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {
    USE_OPERATOR_SUGGEST_EVENT, UseOperatorMessageSuggestEventPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaModelInterface";
import {CoreUiChatHistoryActionsInterface} from "~/core-ui/vue/chat/CoreUiChatHistoryActions";

import OperatorApplicationMessageSuggestedAnswerOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageSuggestedAnswerOpenApiModel;
import OperatorApplicationMessageOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageOpenApiModel;
import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;

const __default__ = {
    name: "CoreUiChatHistorySuggestedAnswer"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    suggestedAnswer: {},
    client: {},
    operatorMessageBackground: {},
    showSeconds: { type: Boolean },
    showSuggestedAnswersButtons: { type: Boolean },
    messageActions: {}
  },
  emits: ["on-height-change", "scroll-to-message"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let compactButtons = ref(false);

function onWidth(width: number) {
    compactButtons.value = width < 520;
}

let message = computed<OperatorApplicationMessageOpenApiModel>(() => {
    let suggest = props.suggestedAnswer;
    let message = createMockMessage(props.client);
    message.dateTime = suggest.timestamp;
    message.operatorLogin = __("Подсказка");
    message.messageType = {
        id: "suggest",
        descr: __("Видна только оператору") + "  ·"
    };
    message.content = suggest.content;

    return message;
});

let localCollapsed = ref(undefined);

let collapsedComputed = computed(() => {
    if (typeof localCollapsed.value === "boolean") {
        return localCollapsed.value;
    }
    return props.suggestedAnswer.isCollapsed;
});

function toggleCollapse() {
    localCollapsed.value = !collapsedComputed.value;
    nextTick(() => {
        emits('on-height-change');
    });
}

function useSuggest(send: boolean) {
    let p: UseOperatorMessageSuggestEventPayloadInterface = {
        username: props.client.username,
        suggest: props.suggestedAnswer,
        send
    };
    OperatorApplicationEventManager.emit(USE_OPERATOR_SUGGEST_EVENT, p);
    localCollapsed.value = true;
}

function goToMessage() {
    emits('scroll-to-message', props.suggestedAnswer.usage.messageId);
    //OperatorApplicationBuddyList.scrollToDialogId(props.client.username, null, props.suggestedAnswer.usage.messageId);
}

let likeRequestInProgress = ref(false);

let sendRateAvailable = computed(() => {
    return !!props.messageActions?.setSuggestRate && !likeRequestInProgress.value;
});

async function setLike(value: boolean) {
    if (props.messageActions?.setSuggestRate) {
        likeRequestInProgress.value = true;
        try {
            let result = await props.messageActions.setSuggestRate(props.suggestedAnswer, value);
            result.showMessageOnError();
        } catch (e) {
        }
        likeRequestInProgress.value = false;
    }
}

onMounted(() => {
    emits('on-height-change');
});

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createBlock(SizeObserverWrapper, { onWidth: onWidth }, {
    default: _withCtx(() => [
      _createVNode(CoreUiChatHistoryMessage, {
        message: _unref(message),
        "operators-dictionary": {},
        "operator-message-background": __props.operatorMessageBackground === _unref(MESSAGE_COLOR_OPERATOR_DARK) ? _unref(MESSAGE_COLOR_COMMENT_OPERATOR_DARK) : _unref(MESSAGE_COLOR_OPERATOR_COMMENT),
        "disallow-short-meta": "",
        "show-seconds": __props.showSeconds,
        "next-message": _unref(message),
        class: _normalizeClass({expanded: !_unref(collapsedComputed), collapsed: _unref(collapsedComputed)}),
        style: {"--core-ui-message-reply-lines":"1"}
      }, _createSlots({
        "before-title": _withCtx(() => [
          _createVNode(FontAwesomeIcon, {
            icon: "lightbulb",
            class: _normalizeClass({
                        'mr-1': true,
                        'message-color': __props.operatorMessageBackground != _unref(MESSAGE_COLOR_OPERATOR_DARK),
                        'text-orange': __props.operatorMessageBackground === _unref(MESSAGE_COLOR_OPERATOR_DARK)
                    })
          }, null, 8, ["class"])
        ]),
        "after-title": _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_unref(collapsedComputed) && typeof __props.suggestedAnswer.isLiked === 'boolean')
                ? _withDirectives((_openBlock(), _createBlock(FontAwesomeIcon, {
                    key: 0,
                    icon: __props.suggestedAnswer.isLiked ? 'thumbs-up' : 'thumbs-down',
                    "icon-style": "solid",
                    class: _normalizeClass({
                                'text-success': __props.suggestedAnswer.isLiked,
                                'text-danger': !__props.suggestedAnswer.isLiked,
                                'mr-2': true
                            })
                  }, null, 8, ["icon", "class"])), [
                    [_directive_my_tooltip, __props.suggestedAnswer.isLiked ? _unref(__)('Подсказка была одобрена') : _unref(__)('Подсказка была не одобрена')]
                  ])
                : _createCommentVNode("", true),
              (!!__props.suggestedAnswer.usage)
                ? _withDirectives((_openBlock(), _createBlock(CoreUiChatHistoryMessageButton, {
                    key: 1,
                    icon: "envelope",
                    "icon-style": "light",
                    "is-client": false,
                    circle: "",
                    onClick: goToMessage
                  }, null, 512)), [
                    [_directive_my_tooltip, _unref(__)(`Подсказка была использована.
Процент схожести текста: %s
Кликните для перехода к сообщению.`, `${__props.suggestedAnswer.usage.similarity}%`)]
                  ])
                : _createCommentVNode("", true),
              _createVNode(CoreUiChatHistoryMessageButton, {
                "is-client": false,
                icon: _unref(collapsedComputed) ? 'chevron-down' : 'chevron-up',
                circle: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCollapse()))
              }, null, 8, ["icon"])
            ])
          ])
        ]),
        _: 2
      }, [
        (!_unref(collapsedComputed))
          ? {
              name: "after-content",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (__props.showSuggestedAnswersButtons)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(CoreUiChatHistoryMessageButton, {
                            icon: "envelope",
                            type: "success",
                            opacity: false,
                            "is-client": false,
                            circle: _unref(compactButtons),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (useSuggest(true)))
                          }, {
                            default: _withCtx(() => [
                              (!_unref(compactButtons))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_unref(__)('Отправить')), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["circle"]),
                          _createVNode(CoreUiChatHistoryMessageButton, {
                            icon: "pencil",
                            "is-client": false,
                            circle: _unref(compactButtons),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (useSuggest(false)))
                          }, {
                            default: _withCtx(() => [
                              (!_unref(compactButtons))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_unref(__)('Изменить')), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["circle"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  (__props.suggestedAnswer.isLikeAvailable || __props.suggestedAnswer.isDislikeAvailable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass({'text-nowrap': !_unref(compactButtons), 'text-right': true})
                      }, [
                        (!_unref(compactButtons))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(__)('Полезна?')), 1))
                          : _createCommentVNode("", true),
                        (__props.suggestedAnswer.isLikeAvailable)
                          ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageButton, {
                              key: 1,
                              disabled: __props.suggestedAnswer.isLiked === true || !_unref(sendRateAvailable),
                              icon: "thumbs-up",
                              "is-client": false,
                              "icon-style": __props.suggestedAnswer.isLiked === true ? 'solid' : 'regular',
                              circle: "",
                              class: _normalizeClass({'text-success': __props.suggestedAnswer.isLiked}),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (setLike(true)))
                            }, null, 8, ["disabled", "icon-style", "class"]))
                          : _createCommentVNode("", true),
                        (__props.suggestedAnswer.isDislikeAvailable)
                          ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageButton, {
                              key: 2,
                              disabled: __props.suggestedAnswer.isLiked === false || !_unref(sendRateAvailable),
                              icon: "thumbs-down",
                              "is-client": false,
                              circle: "",
                              class: _normalizeClass({'text-danger': __props.suggestedAnswer.isLiked === false}),
                              "icon-style": __props.suggestedAnswer.isLiked === false ? 'solid' : 'regular',
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (setLike(false)))
                            }, null, 8, ["disabled", "class", "icon-style"]))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["message", "operator-message-background", "show-seconds", "next-message", "class"])
    ]),
    _: 1
  }))
}
}

})